module.exports = __webpack_public_path__ + "static/media/behance-design-designer-svgrepo-com.34ea0c21.svg";